// API configuration and helpers
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get the full URL for an image from the backend
 * @param {string} imagePath - The image path (e.g., "/api/images/hero1.png" or "hero1.png")
 * @returns {string} Full URL to the image
 */
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '';
  
  // If it's already a full URL, return as is
  if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
    return imagePath;
  }
  
  // Remove leading /api/images/ if present
  let filename = imagePath;
  if (filename.startsWith('/api/images/')) {
    filename = filename.replace('/api/images/', '');
  } else if (filename.startsWith('/api/')) {
    filename = filename.replace('/api/', 'api/');
    return `${BACKEND_URL}/${filename}`;
  }
  
  return `${BACKEND_URL}/api/images/${filename}`;
};

/**
 * Submit contact form to backend
 * @param {Object} formData - Contact form data
 * @returns {Promise<Object>} Response from backend
 */
export const submitContactForm = async (formData) => {
  const response = await fetch(`${BACKEND_URL}/api/contact`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Kļūda nosūtot pieprasījumu');
  }
  
  return response.json();
};

export default { getImageUrl, submitContactForm };
